const VERTICAL_ANIMATION_POSITION = 7

export const getDropdownContentPosition = ({
  dropdownWrapperRef,
  dropdownOverlayNode,
  forceBottom
}: {
  dropdownWrapperRef: React.RefObject<HTMLElement | null>
  dropdownOverlayNode: HTMLDivElement | null
  forceBottom?: boolean
}) => {
  const { width, left, bottom, top } = dropdownWrapperRef.current
    ? dropdownWrapperRef.current.getBoundingClientRect()
    : { width: 0, left: 0, bottom: 0, top: 0 }

  const dropdownContentHeight =
    dropdownOverlayNode?.getBoundingClientRect().height || 0

  const heightWithBottom =
    bottom + dropdownContentHeight + VERTICAL_ANIMATION_POSITION
  const heightWithTop =
    top - dropdownContentHeight - VERTICAL_ANIMATION_POSITION

  const isContentOutOfWindow = forceBottom
    ? false
    : heightWithBottom > window.innerHeight

  const verticalAnimationPosition = isContentOutOfWindow
    ? -VERTICAL_ANIMATION_POSITION
    : VERTICAL_ANIMATION_POSITION

  const isContentNeedToBeResized = forceBottom
    ? heightWithBottom > window.innerHeight
    : heightWithBottom > window.innerHeight && heightWithTop < 0

  const availableHeight = isContentNeedToBeResized
    ? `${window.innerHeight - bottom - VERTICAL_ANIMATION_POSITION}px`
    : 'auto'

  const verticalPosition = isContentOutOfWindow
    ? top - dropdownContentHeight
    : bottom

  return {
    width,
    left,
    verticalPosition,
    verticalAnimationPosition,
    availableHeight
  }
}
